<template>
    <div class="data-trend-chart-wrapper">
        <div class="download-box">
            <Button class="primary-btn" :text="exportBtn" :icon="exportIcon" :hoverIcon="exportIconHover" @btnClick="exportClick" />
        </div>
        <ECharts class="v-echarts" :options="line" autoresize />
    </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import Button from "@/views/zhiji/bComponents/buttons/Button";

export default {
    name: "DataTrendChart",
    props: ["data"],
    components: {
        ECharts,
        Button
    },
    data() {
        return {
            line: null,
            exportIcon: "url(" + this.zhiji.staticPath() + "class-spr.png) -388px -122px",
            exportIconHover: "url(" + this.zhiji.staticPath() + "class-spr.png) -388px -122px"
        };
    },
    computed: {
        exportBtn() {
            return this.$t("zhiji.common.export");
        },
        visitTimes() {
            return this.$t("zhiji.overview.visitTimes");
        },
        visitUserCount() {
            return this.$t("zhiji.overview.visitUserCount");
        },
        questionsNum() {
            return this.$t("zhiji.overview.questionsNum");
        },
        enterQuesNum() {
            return this.$t("zhiji.overview.enterQuesNum");
        },
        questionCount() {
            return this.$t("zhiji.overview.questionCount");
        },
        inputQuesCount() {
            return this.$t("zhiji.overview.inputQuesCount");
        }
    },
    watch: {
        exportBtn() {
            this.line = this.getOptions();
        },
        data() {
            this.line = this.getOptions();
        }
    },
    mounted() {
        this.line = this.getOptions();
    },
    methods: {
        exportClick() {
            this.$emit("trendDataExportHandle");
        },
        getOptions() {
            return {
                color: ["#D9E4EF", "#3FBDFF", "#FF886E", "#FDDB50", "#358866", "#D36700"],
                legend: {
                    data: [
                        {
                            name: this.visitTimes, // 访问次数
                            icon: "circle"
                        },
                        {
                            name: this.visitUserCount, // 访问人数
                            icon: "circle"
                        },
                        {
                            name: this.questionsNum, // 提问量
                            icon: "circle"
                        },
                        {
                            name: this.questionCount, // 提问人数
                            icon: "circle"
                        },
                        {
                            name: this.enterQuesNum, // 输入提问量
                            icon: "circle"
                        },
                        {
                            name: this.inputQuesCount, // 输入提问人数
                            icon: "circle"
                        }
                    ],
                    left: 0,
                    itemGap: 20
                },
                tooltip: {
                    trigger: "axis",
                    textStyle: {
                        align: "left"
                    }
                },
                grid: {
                    left: "40",
                    right: "60",
                    bottom: "20",
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show: false
                        }
                    }
                },
                xAxis: {
                    type: "category",
                    boundaryGap: false,
                    axisLine: {
                        lineStyle: {
                            color: "#B2BBDF"
                        }
                    },
                    axisLabel: {
                        color: "#41475e",
                        padding: [8, 0, 0, 0]
                    },
                    data: this.data && this.data.xAxisData
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        show: false,
                        symbol: "none"
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "#ECF1F7"
                        }
                    }
                },
                series: this.getSeries({
                    visitCount: this.data && this.data.visitCount, // 访问次数
                    userCount: this.data && this.data.userCount, // 访问人数
                    questionNum: this.data && this.data.questionNum, // 提问量
                    questionUser: this.data && this.data.questionUser, // 提问人数
                    inputQuesNum: this.data && this.data.inputQuesNum, // 输入提问量
                    inputQuesUser: this.data && this.data.inputQuesUser // 输入提问人数
                })
            };
        },
        getSeries(datas) {
            const lines = [
                {
                    name: this.visitTimes,
                    color: "#D9E4EF",
                    id: "visitCount"
                },
                {
                    name: this.visitUserCount,
                    color: "#3FBDFF",
                    id: "userCount"
                },
                {
                    name: this.questionsNum,
                    color: "#FF886E",
                    id: "questionNum"
                },
                {
                    name: this.questionCount,
                    color: "#FDDB50",
                    id: "questionUser"
                },
                {
                    name: this.enterQuesNum,
                    color: "#358866",
                    id: "inputQuesNum"
                },
                {
                    name: this.inputQuesCount,
                    color: "#D36700",
                    id: "inputQuesUser"
                }
            ];

            return lines.map(function(line) {
                return {
                    name: line.name,
                    type: "line",
                    smooth: true,
                    itemStyle: {
                        normal: {
                            lineStyle: {
                                color: line.color
                            }
                        }
                    },
                    data: datas && datas[line.id] ? datas[line.id] : []
                };
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.data-trend-chart-wrapper {
    height: 386px;
    width: 100%;
    margin-bottom: 35px;

    .v-echarts {
        width: 100%;
        height: 100%;
    }

    .download-box {
        font-weight: 700;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        margin-bottom: 8px;
        .button-wrapper {
            color: #fff;
            border-radius: 30px;
            background: #2ec2ff;
            box-shadow: 0 0 6px 2px rgba(46, 98, 151, 0.2);
            min-width: 96px;
            font-weight: normal;
            justify-content: center;
            &:hover {
                background: rgba(46, 194, 255, 0.8);
            }
        }
    }
}
</style>
